var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h-titles',[_c('h1',{staticClass:"title h2"},[_vm._v("Serveurs")]),_c('b-card',{attrs:{"no-body":""}},[_c('servers-table',{attrs:{"servers":_vm.servers}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }